// extracted by mini-css-extract-plugin
module.exports = {"ogamiPageWrapper":"style_ogamiPageWrapper__jUzJQ","ogamiPageBlock":"style_ogamiPageBlock__G_Bkr","ogamiPageSoon":"style_ogamiPageSoon__zdqcC"};